import React from "react";
import {
  AppstoreOutlined,
  DollarOutlined,
  LaptopOutlined,
  MailOutlined,
  PhoneOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { Permissions } from "../scripts/settings";

// account
import AccountLayout from "../layouts/Account";
import LoginPage from "../pages/Login";

// app
import BasicLayout from "../layouts/Basic";
import CategoriesPage from "../pages/Categories";
import DashboardPage from "../pages/Dashboard";
import MessagesPage from "../pages/Messages";
import OrdersPage from "../pages/Orders";
import PhoneOrdersPage from "../pages/PhoneOrders";
import ProductsPage from "../pages/Products";
import SettingsPage from "../pages/Settings";
import SpecialOffersPage from "../pages/SpecialOffers";
import UsersPage from "../pages/Users";
import UserApp from "../pages/UserApp";
import AppDownloadManagement from "../pages/AppDownloadManagment";
import BankPage from "../pages/Bank";
import RemittancePage from "../pages/Remittance";
import PrintBarcode from "../pages/PrintBarcode";
import BarcodeReport from "../pages/BarcodeReport";
import SuspendOrders from "../pages/SuspendOrders";

// errors
import NotFoundPage from "../pages/NotFound";
import UnAuthorizedPage from "../pages/UnAuthorized";

import Resources from "./resources";
import CirculationProduct from "../pages/CirculationProduct";

export default [
  // errors
  {
    path: "/403",
    name: "unauthorized",
    component: UnAuthorizedPage,
  },
  {
    path: "/404",
    name: "notfound",
    component: NotFoundPage,
  },
  // account
  {
    path: "/account",
    name: "account",
    component: AccountLayout,
    routes: [
      {
        path: "/account",
        redirect: "/account/login",
      },
      {
        path: "/account/logout",
        redirect: "/account/login",
      },
      {
        path: "/account/login",
        name: "login",
        title: Resources.login,
        component: LoginPage,
      },
    ],
  },
  // app
  {
    path: "/",
    name: "app",
    component: BasicLayout,
    routes: [
      {
        name: "dashboardRedirect",
        path: "/",
        redirect: "/dashboard",
        hidden: true,
      },
      {
        name: "dashboard",
        icon: <LaptopOutlined />,
        path: "/dashboard",
        title: Resources.dashboard,
        component: DashboardPage,
      },
      {
        name: "users",
        icon: <UserOutlined />,
        path: "/users",
        title: Resources.users,
        component: UsersPage,
        authority: Permissions.user_list,
      },
      // {
      //   name: "usersInstalledApp",
      //   icon: <UserOutlined />,
      //   path: "/users_app",
      //   title: Resources.usersApp,
      //   component: UserApp,
      //   authority: Permissions.user_list,
      // },
      {
        name: "phoneOrders",
        icon: <PhoneOutlined />,
        path: "/phoneorders",
        title: Resources.registerOrders,
        component: PhoneOrdersPage,
        authority: Permissions.voip_list,
      },
      {
        name: "phoneOrders",
        path: "/phoneorders/:phone",
        component: PhoneOrdersPage,
        authority: Permissions.voip_list,
        hidden: true,
      },

      {
        name: "orders",
        icon: <ShoppingCartOutlined />,
        path: "/orders",
        title: Resources.reports,
        component: OrdersPage,
        authority: Permissions.cart_list,
      },


      {
        name: "suspendOrders",
        icon: <ShoppingCartOutlined />,
        path: "/suspendOrders",
        title: Resources.suspendReports,
        component: SuspendOrders,
        authority: Permissions.cart_list,
      },
      {
        name: "barcode_reports",
        icon: <ShoppingCartOutlined />,
        path: "/barcode_reports",
        title: Resources.barcode_reports,
        component: BarcodeReport,
        authority: Permissions.cart_list,
      },
      // {
      //   name: "orders",
      //   path: "/orders/:phone",
      //   component: OrdersPage,
      //   authority: Permissions.cart_list,
      //   hidden: true,
      // },
      // {
      //   name: "specialOffers",
      //   icon: <DollarOutlined />,
      //   path: "/specialoffers",
      //   title: Resources.specialOffers,
      //   component: SpecialOffersPage,
      //   authority: Permissions.special_list,
      // },
      // {
      //   name: "categories",
      //   icon: <AppstoreOutlined />,
      //   path: "/categories",
      //   title: Resources.category,
      //   component: CategoriesPage,
      //   authority: Permissions.category_list,
      // },
      // {
      //   name: "banks",
      //   icon: <AppstoreOutlined />,
      //   path: "/banks",
      //   title: Resources.banks,
      //   component: BankPage,
      //   authority: Permissions.category_list,
      // },
      //
      // {
      //   name: "remittance",
      //   icon: <AppstoreOutlined />,
      //   path: "/remittance",
      //   title: Resources.remittance,
      //   component: RemittancePage,
      //   authority: Permissions.remittance_list,
      // },
      {
        name: "products",
        icon: <ShoppingOutlined />,
        path: "/products",
        title: Resources.products,
        component: ProductsPage,
        authority: Permissions.product_list,
      },
      {
        name: "printBarcode",
        icon: <ShoppingOutlined />,
        path: "/printBarcode",
        title: Resources.printBarcode,
        component: PrintBarcode,
        authority: Permissions.print_barcode,
      },
      {
        name: "circulationProducts",
        icon: <ShoppingOutlined />,
        path: "/circulationProducts",
        title: Resources.circulationProducts,
        component: CirculationProduct,
        authority: Permissions.product_list,
      },
      // {
      //   name: "products",
      //   path: "/products/:catId/:subCatId",
      //   component: ProductsPage,
      //   authority: Permissions.product_list,
      //   hidden: true,
      // },
      //     {
      //     name: 'delivery',
      //     icon: <DingtalkOutlined />,
      //     path: '/couriers',
      //     title: Resources.delivery,
      //     component: CouriersPage,
      //     authority: Permissions.postman_list
      // },
      // {
      //   name: "messages",
      //   icon: <MailOutlined />,
      //   path: "/messages",
      //   title: Resources.messages,
      //   component: MessagesPage,
      //   authority: Permissions.message_list,
      // },
      {
        name: "settings",
        icon: <SettingOutlined />,
        path: "/settings",
        title: Resources.settings,
        component: SettingsPage,
        authority: Permissions.setting_list,
      },

      // {
      //   name: "appDownload",
      //   icon: <SettingOutlined />,
      //   path: "/download-app",
      //   title: "مدیریت اپلیکیشن",
      //   component: AppDownloadManagement,
      //   authority: Permissions.setting_list,
      // },
    ],
  },
];
